/*
 * @Author: zhaozhuo
 * @Date: 2021-12-06 15:03:07
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-01-26 16:14:24
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\request\api\recruitment.js
 */
import { post, get } from '../axios'
const recruitment = {
	// 获取中心列表
	getCenterList: (researchCode) =>
		get(`/web/center/getCenterList?researchCode=${researchCode}`),
	// 查询招募中心表单列表
	getRecruitFormList: (params) =>
		get(`/web/recruitCenter/queryRecruitConfig/${params}`),
	// 提交招募中心表单列表
	saveRecruitFormList: (params) => post('/web/recruitCenter/saveRecruitForm', params),
	// 获取招募中心配置
	getRecruitConfigInfo: params => get(`/web/recruitCenter/getRecruitConfigInfo/${params}`),
	// 查询招募列表
	getRecruitList: params => post('web/recruitCenter/queryRecruitList', params),
	// 审核通过
	updateApproved: (subjectCode, code) => post(`/web/recruitCenter/updateApproved/${subjectCode}/${code}`),
	// 审核驳回
	updateReject: params => post(`/web/recruitCenter/updateReject`, params),
	// 医生驳回患者提交的招募信息
	rejectRecruitForm: params => post(`/web/recruitCenter/updateRecruitReject`, params),
	// 查询受试者是否已经被关联
	checkRelation: params => get(`/web/recruitCenter/checkRelationBySubjectCode/${params}`),
	// 解除绑定
	removeBind: (subjectCode, code) => post(`/web/recruitCenter/removeBind/${subjectCode}/${code}`),
	// 刪除招募
	deleteRecruit: params => post(`/web/recruitCenter/deleteRecruit/${params}`),
	// 查询关注公众号医生列表
	getRecruitDoctorList: (researchCode, centerCode, type) => get(`/web/userWechat/getUserList/${researchCode}/${centerCode}/${type}`),
	// 查询提交的招募表单详情
	getRecruitFormInfo: (recruitCode) => get(`/web/recruitCenter/getRecruitByCode/${recruitCode}`)
}
export default recruitment